export default __webpack_public_path__ + "static/media/KuttiCar.160cb628.svg";